import React, { useState } from "react";
import { ReportFullView } from "../components/ReportFullView";
import PayPeriodContract from "../contracts/PayPeriodContract";
import { useSearchParams } from "react-router-dom";

export const ReportNewTab = () => {
	const [spreadNewWindow, setSpreadNewWindow] = useState(null);
	const [searchParams, setSearchParams] = useSearchParams();
	return (
		<div>
			{ <ReportFullView payPeriod={new PayPeriodContract(searchParams.get("payPeriod"), searchParams.get("isPending") === "true")} clientNumber={searchParams.get("clientNumber")} spread={spreadNewWindow} setSpread={setSpreadNewWindow}></ReportFullView> }
		</div>
	);
};